import { v4 as uuidv4 } from 'uuid';

export const ASSIGNMENT_TRACE_HEADER = 'X-Activix-Assignment-Trace';

const assignmentFields = [
    'user_id',
    'second_user_id',
    'bdc_user_id',
    'second_bdc_user_id',
    'secondary_user_id',
    'commercial_id',
    'service_advisor_id',
    'service_agent_id',
];
const sources = [
    'desktop_email_notify',
    'desktop_call_notify',
    'desktop_communication_notify',
    'desktop_existing_lead_completion',
    'desktop_other_assignment',
] as const;

export const assignmentTraceOptions = (
    payload: unknown,
    source?: unknown,
    createId: () => string = uuidv4
): { headers: Record<string, string> } | undefined => {
    try {
        if (
            !payload ||
            typeof payload !== 'object' ||
            Array.isArray(payload) ||
            !assignmentFields.some((field) => Object.hasOwn(payload, field))
        ) {
            return undefined;
        }
        const actionId = createId();
        if (
            typeof actionId !== 'string' ||
            !/^[\da-f]{8}-[\da-f]{4}-4[\da-f]{3}-[89ab][\da-f]{3}-[\da-f]{12}$/i.test(actionId)
        ) {
            return undefined;
        }
        return {
            headers: {
                [ASSIGNMENT_TRACE_HEADER]: JSON.stringify({
                    v: 1,
                    action_id: actionId,
                    source: sources.includes(source as (typeof sources)[number])
                        ? source
                        : 'desktop_other_assignment',
                }),
            },
        };
    } catch {
        // Correlation must not change the business operation when metadata creation fails.
        return undefined;
    }
};
